import { type Schema, type ForeignKeySchemaType, isForeignKeySchemaType } from "common/data/schema";
import { SchemaVisitorBase } from "common/data/schemaVisitorBase";
import { DocSchemaLibrary } from "schemas-common/docSchema";

export class SchemaKindPresenceVisitor extends SchemaVisitorBase {
  public found = false;
  private readonly seen = new Set<Schema>();

  constructor(private readonly target: ForeignKeySchemaType) {
    super();
  }

  override visit(schema: Schema): void {
    if (this.found || this.seen.has(schema)) {
      return;
    }
    this.seen.add(schema);
    if (schema.kind === this.target) {
      this.found = true;
      return;
    }
    super.visit(schema);
  }

  override visitTypeIdentifier(schema: any): void {
    const referenced = DocSchemaLibrary[(schema as any).name as string];
    if (referenced) {
      this.visit(referenced);
    }
  }
}

export class ForeignKeyPresenceVisitor extends SchemaVisitorBase {
  public found = false;
  private readonly seen = new Set<Schema>();

  override visit(schema: Schema): void {
    if (this.found || this.seen.has(schema)) {
      return;
    }
    this.seen.add(schema);
    if (isForeignKeySchemaType(schema.kind)) {
      this.found = true;
      return;
    }
    super.visit(schema);
  }

  override visitTypeIdentifier(schema: any): void {
    const referenced = DocSchemaLibrary[(schema as any).name as string];
    if (referenced) {
      this.visit(referenced);
    }
  }
}
